import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Button, Col, Divider, Modal, Row } from 'antd';

import './style.scss';

const ModalUnsaveModel = ({ open, closeModal, hendleReset }) => {
  const { t } = useTranslation('');
  return (
    <Modal
      width={700}
      className="modal-content-paper"
      open={open}
      onCancel={closeModal}
      footer={null}
      zIndex={1620}
    >
      <Row justify="start">
        <Col className="modal-title">{t('UNSAVED_CHANGES')}</Col>
      </Row>
      <Divider className="modal-divider" />
      <Row justify="start" className="modal-text-wrapper">
        <Col>
          <p className="modal-description">{t('YOU_WANT_WITHOUT_SAVING_ON')}</p>
          <p className="modal-description">{t('YOU_WANT_WITHOUT_SAVING_TWO')}</p>
        </Col>
      </Row>
      <Row justify="end" style={{marginTop: '50px'}}>
        <Col>
          <Button className="modal-action-btn cancel-btn" onClick={closeModal}>
            {t('CANCEL')}
          </Button>
          <Button className="modal-action-btn save-btn" onClick={hendleReset} style={{paddingInline: '24px', marginLeft: '12px'}}>
            {t('YES')}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalUnsaveModel;

ModalUnsaveModel.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  hendleReset: PropTypes.func,
};
